import React from 'react';
import { Route } from 'react-router-dom';
import { featureFlags } from '../../config/featureFlags';

interface StartRoutePages {
  Discovery: React.ComponentType;
  ProcessPlaceholder: React.ComponentType;
  Start: React.ComponentType;
  ProcessGeneral: React.ComponentType;
  ProcessSkills: React.ComponentType;
}

/**
 * The element of the `start` child of `agents/new` (SL-2025): on, the start
 * screen with the name check; off, today's Discovery. The router declares
 * `<Route path="start">` itself so the docs' route scanner
 * (docs/scripts/capabilities.js) sees a literal path.
 *
 * processAgents flag (SL-2025): remove once SL-2050 lands
 */
export function agentSetupStartElement(pages: StartRoutePages): React.ReactElement {
  const { Discovery, Start } = pages;
  return featureFlags.processAgents ? <Start /> : <Discovery />;
}

/**
 * The `process` and `skills` children of `agents/new` (SL-2025), mounted next
 * to the `start` route. On, the process wizard (General at `process`, then
 * Skills; Location and Access are shared). Off, today's placeholder and no
 * `skills` route. The pages come in from the router so they stay lazy there.
 *
 * processAgents flag (SL-2025): remove once SL-2050 lands
 */
export function agentSetupStartRoutes(pages: StartRoutePages): React.ReactElement[] {
  const { ProcessPlaceholder, ProcessGeneral, ProcessSkills } = pages;
  if (!featureFlags.processAgents) {
    return [<Route key="process" path="process" element={<ProcessPlaceholder />} />];
  }
  return [
    <Route key="process" path="process" element={<ProcessGeneral />} />,
    <Route key="skills" path="skills" element={<ProcessSkills />} />,
  ];
}
